exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-popup-toggle-button {\n  display: inline-block;\n}\n\n  upd-popup-toggle-button > button {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    background: none;\n    border: none;\n  }\n", ""]);

